const initialState = {
    assignments: [],
};

export const getAssignmentsReducer = (state = initialState, action) => {
    switch(action.type) {
        case "SET_ASSIGNMENTS":
            return {
                ...state,
                assignments: action.payload
            };
        default:
            return state;
    }
};
